<template>
    <div class="product-view">
        <div class="banner-box"></div>
        <div class="first-box">
            <div class="bold font-40 text-center u-m-t-50 line-1">{{ first_obj.title }}</div>
            <div class="first-box-sub font-18 text-center u-m-b-20 line-1 u-m-t-20">{{ first_obj.sub }}</div>
            <div class="safe-area first-box-container">
                <div class="u-flex u-row-center">
                    <div v-for="(item, index) in canvasList" :key="index">
                        <div class="first-empty" v-if="index % 2 == 0" />
                        <ProductCircle :color="item.color" :labelText="item.labelText" :circleArrow="item.circleArrow" :circleCenterText="item.circleCenterText" />
                        <div class="first-empty" v-if="index % 2 != 0" />
                    </div>
                </div>
            </div>
        </div>
        <div class="second-box">
            <div class="bold font-40 text-center u-m-t-50 u-m-b-47">{{ '超多项目部实用功能' }}</div>
            <div class="second-box-items safe-area">
                <div :class="{'second-box-item': item, 'u-flex': true}" v-for="(item, index) in productList" :key="index">
                    <img v-if="item" class="item-icon" :src="require(`@/assets/product/${index + 1}.png`)" alt="">
                    <div v-if="item" class="second-box-item-name bold">{{ item }}</div>
                    <div v-if="!item" class="font-20 more-text">{{ more_text }}</div>
                </div>
            </div>
            <div class="safe-area u-flex u-row-center">
                <div @click="uploads" class="btn-style">{{ btn_text }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductView',
    components: {
      ProductCircle: () => import('@/components/ProductViewCircle/product-view-circle.vue'),
    },
    data() {
        return {
            banner_pic: require('@/assets/product/banner-chanp.png'),
            first_obj: {
                title: '以项目部为核心',
                sub: '多方协作·沉淀数据·信息共享'
            },
            productList: [
                '通知公告', '提醒事项', '我的关注', '我的日志', '纳盘云存储', '随手拍·相册',
                '外部通讯录', '成员名片', '一键发布任务', '一键拨打电话', '项目概况', '招标资料',
                '投标资料', '施工合同', '施工图纸', '图纸自会审', '施工方案', '工程款报审',
                '内业资料', '零星人工', '零星机械', '工程保险', '全员日志', '工期签证',
                '收发文', '设计变更单', '指令单', '联系单', '收方单', '签证单',
                '结算资料', '图纸抽量', '询价比价', '供应合同', '采购订单', '库存',
                '借用/归还', '领用', '余料信息', '保证金/押金', '收发票', '开发票',
                '收支明细', '修订竣工图', '验收资料', '移交/维保', '',
            ],
            btn_text: '下载免费使用',
            more_text: '更多功能，等你来发现...',
            canvasList: [
                {
                    labelText: '办公效率',
                    circleCenterText: '01',
                    circleArrow: 'bottom',
                    color: '#7879F8',
                },
                {
                    labelText: '项目档案',
                    circleCenterText: '02',
                    circleArrow: 'up',
                    color: '#79E5F8',
                },
                {
                    labelText: '造价管理',
                    circleCenterText: '03',
                    circleArrow: 'bottom',
                    color: '#24DD84',
                },
                {
                    labelText: '生产材料',
                    circleCenterText: '04',
                    circleArrow: 'up',
                    color: '#00B7F2',
                },
                {
                    labelText: '成本管控',
                    circleCenterText: '05',
                    circleArrow: 'bottom',
                    color: '#0087E7',
                },
            ]
        }
    },
	methods: {

		uploads(){
			this.$router.push("/download");
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
		
	}
}
</script>

<style lang="scss" scoped>
.product-view {
    .banner-box {
        width: 100%;
        height: 510px;
        background-image: url('../assets/product/banner-chanp.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        top: -90px;
        margin-bottom: -90px;
    }
    .first-box {
        width: 100%;
        background: linear-gradient(45deg, #fff, #D5F0FC);
        padding-bottom: 90px;
        &::before {
            content: '';
            display: table;   
        }
        &-sub {
            color: #6C6C7A;
        }
        &-container {
            width: 1240px;
            height: 564px;
            background-image: url('../assets/product/xmbwhx-img.png');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            .u-flex {
                width: 1100px;
                height: 100%;
                margin: 0 auto;
                justify-content: space-between;
                .first-empty {
                    height: 80px;
                    width: 1px;
                }
            }
        }
    }
    .second-box {
        &::before {
            content: '';
            display: table;   
        }
        background: linear-gradient(to top, #fff, #D6E8FD);
        &-items {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 26px 34px;
        }
        &-item {
            height: 92px;
            background: linear-gradient(0deg, #DBEFFB 0%, #C8E4FC 100%);
            border-radius: 10px;
            border: 1px solid #fff;
            color: #333;
            transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            position: relative;
            overflow: hidden;
            cursor: pointer;
            
            /* 添加3D效果和阴影 */
            transform: translateZ(0);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
            
            /* 添加悬浮效果 */
            &:hover {
                transform: scale(1.08) translateZ(0);
                box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
                z-index: 10;
                
                /* 添加背景色变化 */
                background: linear-gradient(0deg, #C8E4FC 0%, #B0D9FB 100%);
                
                /* 添加边框高亮 */
                
                /* 添加微妙的发光效果 */
                &::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    border-radius: 10px;
                    box-shadow: 0 0 15px rgba(0, 135, 231, 0.3);
                    opacity: 1;
                }
            }
            
            /* 添加悬停时图标放大效果 */
            &:hover .item-icon {
                transform: scale(1.1);
            }
            
            /* 添加悬停时文字颜色变化 */
            &:hover .second-box-item-name {
                color: #0087E7;
            }
            
            .item-icon {
                width: 52px;
                height: 52px;
                margin: 0 22px 0 36px;
                transition: transform 0.3s ease;
            }
            
            .second-box-item-name {
                transition: color 0.3s ease;
            }
        }
        
        .more-text {
            height: 92px;
            display: flex;
            align-items: center;
            justify-content: center;
            // color: #6C6C7A;
            // font-style: italic;
        }
        
        .btn-style {
            border: 1px solid $theme-color;
            color: $theme-color;
            padding: 20px 80px;
            border-radius: 8px;
            cursor: pointer;
            margin: 60px 0 50px;
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
            
            &:hover {
                color: #fff;
                background-color: $theme-color;
                transform: translateY(-3px);
                box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
            }
            
            &:active {
                transform: translateY(-1px);
            }
        }
    }
}

/* 响应式设计 - 在较小屏幕上调整悬停效果 */
@media (max-width: 768px) {
    .product-view .second-box-items {
        grid-template-columns: repeat(2, 1fr);
    }
    
    .product-view .second-box-item:hover {
        transform: scale(1.05);
    }
}

/* 为网格项添加交互动画 */
.second-box-items {
    perspective: 1000px;
}
</style>